var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_html.js
// module id = 190
// module chunks = 1